'use strict';

var ServiceDemandTimeOfDayFilterFactory = function ServiceDemandTimeOfDayFilterFactory(DataFilter, momentService) {
  function ServiceDemandTimeOfDayFilter() {
    DataFilter.call(this, 'service', 'timeOfDay');
  }
  ServiceDemandTimeOfDayFilter.constructor = ServiceDemandTimeOfDayFilter;
  ServiceDemandTimeOfDayFilter.prototype = Object.create(DataFilter.prototype);
  ServiceDemandTimeOfDayFilter.prototype.groupBy = 'departureDateMomentTimeOfDay';
  function getTime(timeString) {
    var timeFormat = timeString.length > momentService.FORMAT.TIME_ISO.length ? momentService.FORMAT.TIME : momentService.FORMAT.TIME_ISO;
    return momentService.of(timeString, momentService.FIELD.DEPARTURE_DATE, timeFormat);
  }
  ServiceDemandTimeOfDayFilter.prototype.filterGroup = function (timesOfDay) {
    return function (timeOfDay) {
      var timeRanges = [];
      for (var i = 0; i < timesOfDay.length; i++) {
        var rangeData = timesOfDay[i].split('-');
        var timeRange = {
          from: undefined,
          to: undefined
        };
        if (rangeData.length > 1) {
          timeRange.from = getTime(rangeData[0]);
          timeRange.to = getTime(rangeData[1]);
        } else {
          timeRange.from = getTime(rangeData[0]);
          timeRange.to = timeRange.from;
        }
        timeRanges.push(timeRange);
      }
      return timeRanges.some(function (timeRange) {
        var departureDateTime = getTime(timeOfDay);
        return !departureDateTime.isBefore(timeRange.from) && !departureDateTime.isAfter(timeRange.to);
      });
    };
  };
  ServiceDemandTimeOfDayFilter.prototype.filter = function (data, range) {
    if (Array.isArray(range) && range.length >= 1) {
      var groups = {};
      var filteredData = [];
      for (var i = 0, len = data.length; i < len; i++) {
        if (data[i]) {
          var key = data[i][this.groupBy];
          if (typeof groups[key] === 'undefined') {
            groups[key] = [];
          }
          groups[key].push(data[i]);
        }
      }
      var filteredGroups = Object.keys(groups).filter(this.filterGroup(range));
      for (var j = 0, length = filteredGroups.length; j < length; j++) {
        filteredData = filteredData.concat(groups[filteredGroups[j]]);
      }
      return filteredData;
    } else {
      return data;
    }
  };
  return ServiceDemandTimeOfDayFilter;
};
ServiceDemandTimeOfDayFilterFactory.$inject = ['DataFilterFactory', 'MomentService'];
module.exports = ServiceDemandTimeOfDayFilterFactory;